import { Injectable } from '@angular/core';
import { BaseNotifier } from './base-notifier';
import { Ref } from '../providers/ref';
import { DarkModeRepositoryProvider } from '../../shared/providers/repository-providers';

@Injectable({ providedIn: 'root' })
export class DarkModeNotifier extends BaseNotifier<boolean> {
  constructor(ref: Ref) {
    super(ref, false);
  }

  private get repo() {
    return this.ref.read(DarkModeRepositoryProvider).instance;
  }

  override async build(): Promise<boolean> {
    await this.restoreState();
    return this.state();
  }

  async toggle(): Promise<void> {
    const isDark = !this.state();
    this.setState(isDark);
    this.applyToDocument();
    await this.repo.save(isDark);
  }

  async setDarkMode(isDark: boolean): Promise<void> {
    this.setState(isDark);
    this.applyToDocument();
    await this.repo.save(isDark);
  }

  private async restoreState(): Promise<void> {
    const stored = await this.repo.load();
    if (stored.success && stored.data !== undefined) {
      this.setState(stored.data);
    }
  }

  private applyToDocument(): void {
    requestAnimationFrame(() => {
      if (this.state()) {
        document.body.classList.add('dark-mode');
        document.documentElement.classList.add('dark-mode');
        document.documentElement.classList.add('p-dark');
      } else {
        document.body.classList.remove('dark-mode');
        document.documentElement.classList.remove('dark-mode');
        document.documentElement.classList.remove('p-dark');
      }
    });
  }
}
